// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"d0fa7f88","563":"918ae73a","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};